// Demo Lens identifiers. Real Lens ids are Firestore/API uuids; these
// reserved slugs never collide with a live account.
export const DEMO_LENS_ID = 'demo'
export const DEMO_REPORT_IDS = {
  TOP_PERFORMING: 'demo-top-performing',
  COMPARATIVE: 'demo-comparative'
}

export const DEMO_REPORT_ID_LIST = Object.values(DEMO_REPORT_IDS)

export const DEMO_FOLDER_ID = 'demo-folder-default'
export const DEMO_PRESET_ID = 'demo-preset-default'
export const DEMO_PRESET_COLUMNS_HASH = 'demo-hash-default'

// Account ids used by the seeded Foreplay (Demo) lens. Two Meta + one TikTok
// so AdAccountFilterSelector and the dashboard tour have something to show.
export const DEMO_AD_ACCOUNTS = {
  META_US: 'demo-meta-1',
  META_PROSPECTING: 'demo-meta-2',
  TIKTOK: 'demo-tt-1'
}

export const DEMO_BUSINESS_IDS = {
  META: 'demo-meta-biz',
  TIKTOK: 'demo-tt-biz'
}

export function isDemoLensId (id) {
  return id === DEMO_LENS_ID
}

export function isDemoReportId (id) {
  return !!id && DEMO_REPORT_ID_LIST.includes(id)
}

export function isDemoLensRoute (params = {}) {
  return isDemoLensId(params.lensId) || isDemoReportId(params.reportId)
}

export function isDemoPresetId (id) {
  return typeof id === 'string' && id.startsWith('demo-preset-')
}

export function isDemoId (id) {
  return isDemoLensId(id) || isDemoReportId(id)
}
